import { render } from "./product-usp.vue?vue&type=template&id=4a1d059a"
import script from "./product-usp.vue?vue&type=script&lang=js"
export * from "./product-usp.vue?vue&type=script&lang=js"

import "./product-usp.vue?vue&type=style&index=0&id=4a1d059a&lang=scss"

import exportComponent from "/Users/riccardosirchia/Projects/dryrobe.com-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__